import { HttpClient } from '@angular/common/http';
import { Injectable, ElementRef } from '@angular/core';
import { ActionApiService } from '../action-api/action-api.service';
import { StoreService } from '../../Services/store';
import { ObservablesService } from '../observables/observables';
import { isArray } from 'lodash';
import { ReplaySubject, Subject } from 'rxjs';
import { LoadTimeService } from '../LoadTimeService/load-time-service';
import { SplunkAnalyticsService } from '../splunk-analytics/splunk-analytics-service';
import { ConfigService } from '../config.service';
import { Router } from '@angular/router';

@Injectable()
export class AddressesService {
	SuggestedOnInit: boolean;
	manualWrite: boolean;
	pendingRequestsCount = 0;
	public autocompleteAddresses: any;
	public isOpen: boolean;
	allCities: string[];
	children: {};
	currentElementRef: ElementRef;
	errObj: string;
	requestBody: request = {
		data: {},
		info: {
			action: '',
			conditions: '',
			elementSrc: '',
			stage: '',
			notRenderPage: false,
		},
	};
	data: any;
	ajaxtInfo: ajaxInfo;
	fullAddress: FullAddress = {
		address1: '',
		address2: '',
		city: '',
		county: '',
		latitude: '',
		state: '',
		zipCode: '',
		longtitude: '',
	};
	showEditAddressReplaySubject: ReplaySubject<boolean> = new ReplaySubject<boolean>();

	constructor(
		private httpClient: HttpClient,
		private actionApiService: ActionApiService,
		private storeService: StoreService,
		private observablesService: ObservablesService,
		private loadTimeService: LoadTimeService,
		private splunkAnalyticsService: SplunkAnalyticsService,
		private configService: ConfigService,
		private router: Router
	) {
		this.isOpen = false;
	}

	async fetchAddresses(controlName, { address1, city, state, zipCode, county, longtitude, latitude }, isInit) {
		this.data = {
			AddressLine1: address1,
			City: city,
			State: state,
			ZipCode: zipCode,
			County: county,
			Longtitude: longtitude,
			Latitude: latitude,
			IsInit: isInit,
		};

		this.ajaxtInfo = {
			action: 'AddressValidation',
			elementSrc: controlName,
			stage: null,
			notRenderPage: true,
			conditions: '',
		};
		this.requestBody = { data: this.data, info: this.ajaxtInfo };

		this.actionApiService.invokeAction(this.requestBody, false, 'fetchAddresses');
	}

	async fetchStateAndCity(control: control, zipCode) {
		this.requestBody = {
			info: {
				action: 'CityStateZip',
				elementSrc: control.name,
				stage: null,
				notRenderPage: true,
				conditions: '',
			},
			data: { ZipCode: zipCode },
		};

		this.actionApiService.invokeAction(this.requestBody, false, 'fetchStateAndCity');
	}

	set El(el: ElementRef) {
		this.currentElementRef = el;
	}

	onAddressBlur(control: control) {
		control.attributes.addressSuggestionOnInit = true;
		this.getFullAddress(control);
		this.getAddressSuggestions(control, false);
	}

	onCityChange(control: control) {
		this.getFullAddress(control);
		this.getAddressSuggestions(control, false);
	}

	getAddressSuggestions(control: control, isInit) {
		// If we reached here from init and we already suggested, do nothing
		if (isInit && this.SuggestedOnInit) {
			return;
		} else {
			this.SuggestedOnInit = true;
		}

		this.autocompleteAddresses = [];

		if (!control.attributes.enableAddressSuggestions) {
			return;
		}

		const { address1, city, state, zipCode, county, longtitude, latitude } = this.fullAddress;

		if (!address1 || !city || !state || !zipCode) {
			return;
		}

		if (this.manualWrite) {
			this.manualWrite = false;
			return;
		}

		this.fetchAddresses(control.name, this.fullAddress, false);
		this.observablesService.fetchAddresses = new Subject<any>(); // Workaround until this is fixed!!
		this.observablesService.fetchAddresses.subscribe((response) => {
			console.log('getAddressSuggestions fetchAddresses', response);

			if (isArray(response)) {
				this.autocompleteAddresses = response;
				setTimeout(() => {
					const isSameAddress = this.autocompleteAddresses[0] && this.autocompleteAddresses[0].SameAddress;
					console.log('getAddressSuggestions setTimeout isSameAddress-', isSameAddress);

					this.isOpen = isSameAddress ? false : true;
					if (isSameAddress) {
						this.storeService.updateData(`${control.name}.Longtitude`, response[0].Longtitude, 'page');
						this.storeService.updateData(`${control.name}.Latitude`, response[0].Latitude, 'page');
						this.getFullAddress(control);
						control.id = Object.assign('', control.id);
					}
				}, 300);
			}
		});
	}

	onZipBlur(control: control, value) {
		this.getFullAddress(control);

		if (value !== undefined) {
			if (value.length === 0) {
				this.storeService.updateData(`${control.name}.City`, '', 'page');
				this.storeService.updateData(`${control.name}.State`, '', 'page');
				this.storeService.updateData(`${control.name}.County`, '', 'page');
				this.storeService.updateData(`${control.name}.ZipCode`, '', 'page');
			}
			const res = {
				control: this.storeService.getControl(control.name, control.controlType, 'page'),
				el: this.currentElementRef,
			};
			this.observablesService.addressChanged.next(res);
			// this.getFullAddress(control);
		}
	}

	async onZipChange(control: control, value, isInit) {
		const minCharsForAutoSuggestion = 5;

		if (control.disabled || !value || (value && value.toString().length < minCharsForAutoSuggestion)) {
			return;
		}
		this.storeService.updateData(`${control.name}.ZipCode`, value, 'page');
		if (!isInit) {
			this.storeService.updateData(`${control.name}.City`, '', 'page');
		}
		this.storeService.updateData(`${control.name}.State`, '', 'page');
		this.storeService.updateData(`${control.name}.County`, '', 'page');
		this.storeService.updateData(`${control.name}.Longtitude`, '', 'page');
		this.storeService.updateData(`${control.name}.Latitude`, '', 'page');
		this.getFullAddress(control);

		await this.fetchStateAndCity(control, value);

		this.observablesService.fetchStateAndCity = new Subject<any>(); // Workaround until this is fixed!!
		this.observablesService.fetchStateAndCity.subscribe(({ cities, state, county, errors }) => {
			if (errors && errors.length > 0) {
				// this.errObj[`${control.name}.ZipCode`] = errors;
				this.storeService.setAddressErrors(`${control.name}.ZipCode`, errors, 'page');
				this.storeService.updateData(`${control.name}.State`, '', 'page');
				this.storeService.updateData(`${control.name}.City`, '', 'page');
				const res = {
					control: this.storeService.getControl(control.name, control.controlType, 'page'),
					isError: true,
				};
				this.observablesService.addressChanged.next(res);
				return;
			}

			if (!cities || !state) {
				return;
			}

			const prevCounty = this.fullAddress.county;

			const currentCity = this.storeService.getValue(`${control.name}.City`, 'page');

			if (isInit && currentCity && cities.indexOf(currentCity) === -1) {
				// Previous city is not in the new city options
				cities.push(currentCity);
			}

			this.allCities = cities.map((city, index) => ({
				title: city,
				image: null,
				value: city,
				sequence: index,
			}));

			if (cities.length === 1) {
				this.storeService.updateControlAttributes(
					`${control.name}.City`,
					'page',
					{
						options: this.allCities,
						disabled: true,
					},
					control.name
				);

				this.storeService.updateData(`${control.name}.City`, cities[0], 'page');
			}

			if (cities.length > 1) {
				this.storeService.updateControlAttributes(
					`${control.name}.City`,
					'page',
					{
						options: this.allCities,
						disabled: false,
					},
					control.name
				);

				this.storeService.updateData(`${control.name}.City`, cities[0], 'page');
			}
			this.storeService.updateData(`${control.name}.State`, state, 'page');
			this.storeService.updateData(`${control.name}.County`, county, 'page');

			this.getFullAddress(control);

			if (cities.length === 1 || county !== prevCounty) {
				this.getAddressSuggestions(control, isInit);
			}
			// this.storeService.updateControlAttributes(
			//   `${control.name}.City`,
			//   'page',
			//   {
			//     options: this.allCities.map((city, index) => ({
			//       title: city,
			//       image: null,
			//       value: city,
			//       sequence: index
			//     })),
			//     disabled: this.allCities.length <= 1
			//   },
			//   `${control.name}`
			// );

			const res = {
				control: this.storeService.getControl(control.name, control.controlType, 'page'),
				el: this.currentElementRef,
			};
			this.observablesService.addressChanged.next(res);
		});
	}

	getFullAddress(control: control) {
		this.fullAddress = Object.assign(this.fullAddress, {
			address1: this.storeService.getValue(`${control.name}.AddressLine1`, 'page'),
			address2: this.storeService.getValue(`${control.name}.AddressLine2`, 'page'),
			city: this.storeService.getValue(`${control.name}.City`, 'page'),
			state: this.storeService.getValue(`${control.name}.State`, 'page'),
			county: this.storeService.getValue(`${control.name}.County`, 'page'),
			zipCode: this.storeService.getValue(`${control.name}.ZipCode`, 'page'),
			longtitude: this.storeService.getValue(`${control.name}.Longtitude`, 'page'),
			latitude: this.storeService.getValue(`${control.name}.Latitude`, 'page'),
		});
	}

	async getGoogleSuggestions(address: FullAddress) {
		let reqId = '';

		reqId = this.loadTimeService.beginTimeMeasure();
		const { address1, city, state, zipCode } = address;

		const url = `https://maps.google.com/maps/api/geocode/json?address=${address1}+${city}+${state}+${zipCode}&key=${
			this.configService.getConfig().GOOGLE_MAPS_CLIENT_ID
		}`.replace(/ /g, '+');

		this.pendingRequestsCount += 1;

		const res = (await this.httpClient.get(url).toPromise()) as any;

		this.loadTimeService.endTimeMeasure(reqId);
		this.pendingRequestsCount -= 1;
		if (!this.pendingRequestsCount) {
			const loadTime = this.loadTimeService.calculateTimeMeasure(reqId);
			this.splunkAnalyticsService.publish('SysEvent', 'GoogleSuggestions', loadTime.loadTime);
			return res;
		}
	}
}
